import React, { useState, useEffect } from "react";
import { css } from "@emotion/react";
import { CometChat } from "@cometchat-pro/chat";
import Messages from "components/chat/shared/Messages";

// mui
import { grey } from "@mui/material/colors";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  root: css`
    height: 500px;
    width: 350px;
    padding: 8px;
    border: solid;
    border-radius: 10px;
    border-color: ${grey[300]};
    background-color: white;
  `,
};
type ChatWidgetProps = {
  guid: string;
  handleClose: (guid: string) => void;
};

const ChatWidget: React.FC<ChatWidgetProps> = (props) => {
  const { guid, handleClose } = props;
  const [group, setGroup] = useState<CometChat.Group | null>(null);

  const fetchGroup = () => {
    CometChat.getGroup(guid).then(
      (g: CometChat.Group) => {
        console.log("Group details fetched successfully:", g);
        setGroup(g);
      },
      (error: any) => {
        console.log("Group details fetching failed with exception:", error);
      },
    );
  };
  useEffect(() => {
    fetchGroup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Stack direction="column">
      <Stack direction="row" justifyContent="flex-end">
        <IconButton size="small" onClick={() => handleClose(guid)}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <div css={style.root}>{group && <Messages group={group} />}</div>
    </Stack>
  );
};

export default ChatWidget;
